import { Theme } from '@mui/material/styles';
import { useRef } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { useBoolean } from 'usehooks-ts';

import { getDataTestId } from '@/utils/browser';

import { Loader } from '../../Icon/Loader';
import { Image } from './Image';

import { ImageViewerContainer, ViewerLoader } from './File.styled';

type ImageViewerProps = {
  url: string;
  alt?: string;
};

export function ImageViewer({ url, alt }: ImageViewerProps) {
  const { value: isLoaded, setTrue: setLoaded } = useBoolean(false);
  const containerRef = useRef<HTMLElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  return (
    <ImageViewerContainer ref={containerRef} {...getDataTestId('image-viewer')}>
      {!isLoaded && (
        <ViewerLoader>
          <Loader
            justifyContent="center"
            iconProps={{
              size: 32,
              color: (theme: Theme) => theme.palette.common.white,
            }}
          />
        </ViewerLoader>
      )}
      <TransformWrapper centerZoomedOut minScale={0.1}>
        {({ centerView, zoomToElement }) => (
          <TransformComponent>
            <Image
              hideLoader
              ref={imgRef}
              src={url}
              alt={alt}
              onLoad={() => {
                setLoaded();
                centerView();
                if (imgRef.current) {
                  zoomToElement(imgRef.current, undefined, 0);
                }
              }}
              onError={setLoaded}
            />
          </TransformComponent>
        )}
      </TransformWrapper>
    </ImageViewerContainer>
  );
}
